import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-protection-service',
  imports: [RouterLink],
  templateUrl: './protection-service.component.html',
  styleUrl: './protection-service.component.scss',
})
export class ProtectionServiceComponent {

}
